import React, { Component } from 'react'
import { connect } from 'react-redux'

// Components
import CreateForm from './CreateForm'
import CreateSuccess from './CreateSuccess'

class CreateAccount extends Component {
    render() {
        const { accountCreateSuccess } = this.props

        return (
            <div className="body_container padded_top padded_bottom">
                <h1>Create Account</h1>
                
                {accountCreateSuccess ? (
                    <CreateSuccess />
                ) : (
                    <CreateForm />
                )}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        accountCreateSuccess: state.user.accountCreateSuccess
    }
}

export default connect(mapStateToProps)(CreateAccount)



// WEBPACK FOOTER //
// ./src/components/customer/create/CreateAccount.js